import OrganizationPaymentStages from './OrganizationPaymentStages';

const STAGES_WITH_ENABLED_FUNCTIONALITIES = [
  OrganizationPaymentStages.trial,
  OrganizationPaymentStages.cardValid,
  OrganizationPaymentStages.cardInvalid,
];

export default STAGES_WITH_ENABLED_FUNCTIONALITIES;
